module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-7.5d7ea4c1.svg";